// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HeaderBlockSlice_wrapper__PehiZ","subtitleYellow":"HeaderBlockSlice_subtitleYellow__FdmpK"};